import Vue from 'vue';
import App from './App.vue';
import Vuex from 'vuex';
import VueSplide from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueSplide);

const store = new Vuex.Store({
    state: {
        products: [],
        activeProduct: null,
        trans: {},
        icons: {},
        currency: {},
        shop: {},
        variationGroup: {},
        usps: [],
        wishlist: {},
        assetUrl: "",
        promotionTrigger: {}
    },
    getters: {
        usps: state => {
            return state.usps;
        },
        wishlist: state => {
            return state.wishlist;
        },
        translations: state => {
            return state.translations;
        },
        activeProduct: state => {
            return state.activeProduct;
        },
        locale: state => {
            return state.locale;
        },
        productMedia: state => {
            return state.activeProduct.media;
        },
        trans: state => {
            return state.trans;
        },
        icons: state => {
            return state.icons;
        },
        currency: state => {
            return state.currency;
        },
        assetUrl: state => {
            return state.assetUrl;
        },
        shop: state => {
            return state.shop;
        },
        variationGroup: state => {
            return state.variationGroup;
        },
        promotionTrigger: state => {
            return state.promotionTrigger;
        }
    },
    mutations: {
        storeIcons(state, payload) {
            state.icons = payload;
        },
        storeCurrency(state, payload) {
            state.currency = payload;
        },
        storeVariationGroup(state, payload) {
            state.variationGroup = payload;
        },
        storeAssetUrl(state, payload) {
            state.assetUrl = payload;
        },
        storeShop(state, payload) {
            state.shop = payload;
        },
        storeTranslations(state, payload) {
            state.trans = payload;
        },
        setActiveProduct(state, payload) {
            state.activeProduct = payload;
        },
        storePromotionTrigger(state, payload) {
            state.promotionTrigger = payload;
        },
        storeUsps(state, payload) {
            state.usps = payload;
        },
        storeWishlist(state, payload) {
            state.wishlist = payload;
        }
    }
});


new Vue({
    render: h => h(App),
    store: store
}).$mount('#app');
